import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

function AppCheckbox({
  checkboxProps,
  label,
  labelProps,
  onChange,
  rootProps = {},
  formControlProps = {},
}: any) {
  if (!label)
    return <Checkbox {...checkboxProps} onChange={onChange && onChange} />;

  return (
    <FormGroup {...rootProps}>
      <FormControlLabel
        control={
          <Checkbox {...checkboxProps} onChange={onChange && onChange} />
        }
        label={label}
        componentsProps={{
          typography: {
            vaiant: "standard",
            fontWeight: 500,
            ...labelProps,
          },
        }}
        {...formControlProps}
      />
    </FormGroup>
  );
}

export { AppCheckbox };
